import { Toast } from '@capacitor/toast';

/* jshint esversion: 6 */
export default {
    async toast (options, onSuccess, onError) {
        await Toast.show({
            text: options.message,
            duration: options.duration ? options.duration : 2000,
            position: options.position ? options.position : 'center'
        });

        onSuccess && onSuccess();
    }
};



// WEBPACK FOOTER //
// ./src/cordova/toast.js